import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useContent, imgUrl } from "@/context/ContentContext";
import { Heart, Users, Sun } from "lucide-react";

const ICONS = [Heart, Users, Sun, Heart];

export default function Community() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [sent, setSent] = useState(false);
  const c = useContent().pages.community;

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/private-events", { name, email, event_type: "Community Program Interest", notes: "Sponsored community arts program interest list" });
      setSent(true);
      toast.success("Thanks — we'll be in touch!");
    } catch { toast.error("Something went wrong"); }
  };

  return (
    <div>
      <section className="bg-forest text-white py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="text-white/70 text-sm tracking-widest uppercase font-medium">{c.eyebrow}</div>
            <h1 className="mt-2 font-serif font-bold text-5xl md:text-6xl leading-tight">{c.heading}</h1>
            <p className="mt-6 text-white/85 text-lg max-w-lg">{c.description}</p>
          </div>
          {c.image && <img src={imgUrl(c.image)} alt="Community" className="rounded-3xl h-96 w-full object-cover"/>}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <h2 className="font-serif text-3xl md:text-4xl font-semibold text-center">{c.programs_heading}</h2>
        <div className="mt-12 grid md:grid-cols-4 gap-6">
          {c.programs.map((p, i) => { const Icon = ICONS[i % ICONS.length]; return (
            <div key={i} className="bg-white rounded-3xl p-8 shadow-card text-center">
              <div className="w-14 h-14 mx-auto rounded-full bg-forest/10 grid place-items-center"><Icon size={24} className="text-forest" strokeWidth={1.5}/></div>
              <h3 className="mt-4 font-serif text-lg font-semibold">{p.title}</h3>
            </div>
          ); })}
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 lg:px-8 py-16 grid md:grid-cols-3 gap-6">
        {c.cards.map((card, i) => (
          <div key={i} className="bg-cream-alt rounded-3xl p-8">
            <h3 className="font-serif text-xl font-semibold">{card.title}</h3>
            <p className="mt-2 text-charcoal/70">{card.description}</p>
          </div>
        ))}
      </section>

      <section className="max-w-2xl mx-auto px-6 lg:px-8 py-16">
        {sent ? (
          <div className="bg-white rounded-3xl p-8 shadow-card text-center" data-testid="community-confirm">
            <h3 className="font-serif text-2xl font-semibold text-forest">Thanks!</h3>
            <p className="mt-2 text-charcoal/70">We'll reach out about upcoming community programming.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-white rounded-3xl p-8 shadow-card" data-testid="community-form">
            <h3 className="font-serif text-2xl font-semibold">{c.form_heading}</h3>
            <div className="mt-4 grid gap-3">
              <input required data-testid="community-name" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} className="rounded-2xl border border-cream-alt px-4 py-3 focus:ring-2 focus:ring-forest focus:outline-none"/>
              <input required data-testid="community-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-2xl border border-cream-alt px-4 py-3 focus:ring-2 focus:ring-forest focus:outline-none"/>
              <button data-testid="community-submit" type="submit" className="rounded-full bg-forest text-white px-8 py-3.5 font-semibold">{c.form_button_label}</button>
            </div>
          </form>
        )}
      </section>
    </div>
  );
}
